import { Component, Input, OnInit } from '@angular/core';
import { tPrescriptionHeadModel } from 'src/app/models/tPrescriptionHeadModel';
import { tPrescriptionLineModel_withStock } from 'src/app/models/tPrescriptionLineModel';

@Component({
  selector: 'app-debug_ttp_244_pro_label_printer',
  templateUrl: './debug_ttp_244_pro_label_printer.component.html',
  styleUrls: ['./debug_ttp_244_pro_label_printer.component.css']
})
export class Debug_ttp_244_pro_label_printerComponent implements OnInit {
  
  @Input() header: tPrescriptionHeadModel;
  @Input() line: tPrescriptionLineModel_withStock[];
  @Input() printMode: number;

  constructor() { }

  ngOnInit() {
  }

}
